<script>
  export let src;
  export let style;
</script>

<img class="locked-icon" {style} {src} alt="Icon" />

<style>
  .locked-icon {
    width: 5rem;
  }
</style>
